import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Users } from 'src/app/models/interfaces/users';
import { Location } from '@angular/common';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Employees } from '../../../interfaces/employees';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';

export function atLeastOneDaySelectedValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const days = control.get('days')?.value as string[];
    if (days && days.length > 0) {
      return null; // La validación pasa si al menos un día está seleccionado
    } else {
      return { atLeastOneDaySelected: true }; // La validación falla si ningún día está seleccionado
    }
  };
}
@Component({
  selector: 'app-edit-employees',
  templateUrl: './edit-employees.component.html',
  styleUrls: ['./edit-employees.component.css']
})
export class EditEmployeesComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal,
    private location: Location
  ) {}
  ngOnInit(): void {
    this.getState();
    if (this.employees != null) {
      this.get(this.employees);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['employees'].currentValue!=this.employees) {
      this.get(this.employees);
    }
  }
  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  employees: Employees;
  items:any;
  allDays: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  form1: FormGroup = this.formBuilder.group({
    id:[],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    email: [''],
    phone: [''],
    state_id:[0],
    stores_id: [0],
    days: [''],
    xdays: [[]]
  }, { validators: atLeastOneDaySelectedValidator() });

  get(item: Employees) {
    this.api.getEmployee(item?.id).subscribe((res)=>{
      let data=res.data as Employees;
      this.form1.patchValue(res.data);
      this.form1.get('rutview')?.setValue(data?.rut);
      // Dividir la cadena de días en un arreglo de días seleccionados
    const selectedDays = data.days.split(',');

    // Asignar los días seleccionados al control "xdays" del formulario
    this.form1.get('xdays')?.setValue(selectedDays);
    },error=>{
      this.toast.warning(error.error.mistakes,error.error.msg,{enableHtml:true,closeButton:true});
      this.modal.dismissAll();
    });
  }
  getState(){
    this.apiFull.getState().subscribe((res)=>{
      this.items=res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    const selectedDays = this.form1.value.xdays as string[];
    const daysString = selectedDays ? selectedDays.join(',') : '';
    this.form1?.get('days')?.setValue(daysString);
    this.api.updateEmployees(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Empleados');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg,{enableHtml:true,closeButton:true});
      }
    );
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
  toggleDaySelection(day: string): void {
    const xdaysControl = this.form1.get('xdays');
  
    const currentValue = xdaysControl.value || [];
    const selectedIndex = currentValue.indexOf(day);
  
    if (selectedIndex === -1) {
      // Si el día no está seleccionado, agrégalo
      currentValue.push(day);
    } else {
      // Si el día está seleccionado, retíralo
      currentValue.splice(selectedIndex, 1);
    }
  
    xdaysControl.setValue(currentValue);
  }
}
